import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import PremiumHome from './PremiumHome';
import API_BASE_URL from '../config/api';

function Home() {
  const { token, user } = useAuth();
  const navigate = useNavigate();
  const [products, setProducts] = useState(() => {
    // Load from cache immediately
    try {
      const cached = localStorage.getItem('products_cache');
      return cached ? JSON.parse(cached) : [];
    } catch (e) {
      return [];
    }
  });
  const [categories, setCategories] = useState(() => {
    // Load from cache immediately
    try {
      const cached = localStorage.getItem('categories_cache');
      return cached ? JSON.parse(cached) : [];
    } catch (e) {
      return [];
    }
  });

  useEffect(() => {
    // Fetch fresh data in background
    const fetchData = async () => {
      try {
        const [productsRes, categoriesRes] = await Promise.all([
          fetch(`${API_BASE_URL}/api/products`),
          fetch(`${API_BASE_URL}/api/products/categories/all`),
        ]);

        const productsData = await productsRes.json();
        const categoriesData = await categoriesRes.json();

        const prods = productsData.data || [];
        const cats = categoriesData.data || [];

        // Update state
        setProducts(prods);
        setCategories(cats);

        // Cache for next load
        localStorage.setItem('products_cache', JSON.stringify(prods));
        localStorage.setItem('categories_cache', JSON.stringify(cats));
      } catch (error) {
        console.log('Could not fetch data');
      }
    };

    // Fetch in background
    fetchData();
  }, []);

  // Render immediately with cached data
  return <PremiumHome products={products} categories={categories} />;
}

export default Home;
